import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { TableCell, TableRow } from '@mui/material';

const ShippingProfile = ({ id, name, status, index, deleteShippingProfile }) => {
  const styles = {
    indexColumn: {
      width: '50px'
    }
  };

  return (
    <TableRow key={id}>
      <TableCell component="th" scope="row" sx={styles.indexColumn}>
        <Link to={`shipping-profiles/${id}/edit`}>{index}</Link>
      </TableCell>
      <TableCell component="th" scope="row">
        <Link to={`shipping-profiles/${id}/edit`}>{name}</Link>
      </TableCell>
      <TableCell component="th" scope="row">{status}</TableCell>
      <TableCell align="left">
        <Link to={`shipping-profiles/${id}/edit`}>
          <IconButton color="primary" size="small"><EditIcon /></IconButton>
        </Link>
        <IconButton color="error" size="small" onClick={() => { if (window.confirm('Are you sure?')) deleteShippingProfile() }}>
          <DeleteIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

ShippingProfile.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  fulfillment_center_name: PropTypes.string,
  index: PropTypes.number.isRequired,
  deleteShippingProfile: PropTypes.func.isRequired,
};

export default ShippingProfile;
